var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExploreGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.9999 11.9999C21.9999 17.5229 17.5229 21.9999 11.9999 21.9999C6.47688 21.9999 1.99988 17.5229 1.99988 11.9999C1.99988 6.47788 6.47688 1.99988 11.9999 1.99988C17.5229 1.99988 21.9999 6.47788 21.9999 11.9999Z",
    fill: "#00A79D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8598 8.70487L14.2398 13.8249C14.1798 14.0349 14.0098 14.2049 13.7998 14.2659L8.69984 15.8649C8.35984 15.9759 8.02984 15.6449 8.13984 15.3049L9.73984 10.1749C9.79984 9.96487 9.96984 9.80487 10.1798 9.73487L15.2998 8.13487C15.6498 8.02487 15.9698 8.35487 15.8598 8.70487Z",
    fill: "#00A79D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreGreen);
export default __webpack_public_path__ + "static/media/explore-green.66507e7ffe93d31c96e4f3f07805b7e2.svg";
export { ForwardRef as ReactComponent };